import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  ShoppingCart,
  ArrowLeft,
  X,
  Star,
  Sparkles,
  BookOpen,
} from "lucide-react";
import styles from "./BestSeller.module.css";

const BEST_SELLERS = [
  {
    id: 1,
    title: "Education Strategies بالعربي 11",
    subtitle: "العنوان الفرعي لـ Education Strategies 11",
    tag: "الرياضيات",
    level: "الصف الثاني الثانوي",
    price: 259,
    oldPrice: 312,
    discount: "%16.99-",
    desc: "الوصف الخاص بـ Education Strategies 11 الفاخر والشامل لكل استراتيجيات التعليم الحديثة لطلاب المرحلة الثانوية.",
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=600",
    author: "Author",
  },
  {
    id: 2,
    title: "Psychology Basics",
    subtitle: "أساسيات علم النفس التعليمي",
    tag: "اللغة التركية",
    level: "الصف الأول الثانوي",
    price: 270,
    oldPrice: 321,
    discount: "%15.8-",
    desc: "كتاب شامل ومبسط لفهم أساسيات السلوك وعلم النفس التربوي مدعم بالخرائط الذهنية.",
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=600",
    author: "Author",
  },
  {
    id: 3,
    title: "Classroom Management",
    subtitle: "إدارة الفصل الذكية",
    tag: "الرياضيات البحتة",
    level: "الصف الثالث الثانوي",
    price: 234,
    oldPrice: 295,
    discount: "%20.6-",
    desc: "دليلك المهني لاحتواء وتوجيه الطلاب داخل البيئة الصفية بشكل تفاعلي ومثمر.",
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=600",
    author: "Author",
  },
  {
    id: 4,
    title: "Advanced Pedagogy",
    subtitle: "طرق التدريس المتقدمة",
    tag: "اللغة الإنجليزية",
    level: "الصف الثاني الثانوي",
    price: 285,
    oldPrice: 340,
    discount: "%16.1-",
    desc: "أحدث ما توصلت إليه الأبحاث العالمية في استراتيجيات إيصال المعلومة وتثبيتها.",
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=600",
    author: "Author",
  },
];

const BestSeller = () => {
  const [showAll, setShowAll] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);

  const visibleBooks = showAll ? BEST_SELLERS : BEST_SELLERS.slice(0, 4);

  return (
    <section className={styles.showcaseSection}>
      <div className={styles.webContainer}>
        <div className={styles.topHeader}>
          <div className={styles.headingBlock}>
            <span className={styles.sectionSubtitle}>
              تصفح الاختيارات الأعلى تقييماً
            </span>
            <h2 className={styles.sectionTitle}>الأكثر مبيعاً</h2>
          </div>
          <button
            className={styles.toggleGridBtn}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "عرض أقل" : "عرض الكل"}
            <ArrowLeft
              size={18}
              className={showAll ? styles.arrowRotated : ""}
            />
          </button>
        </div>

        <div className={styles.dashboardGrid}>
          <div className={styles.stickyIntroCard}>
            <div className={styles.cardHeaderDecoration}>
              <div className={styles.dotsGroup}>
                <span className={styles.decoDot} />
                <span className={styles.decoDot} />
                <span className={styles.decoDot} />
              </div>
              <span className={styles.orangeBadge}>
                <Sparkles size={14} /> مميزاتنا
              </span>
            </div>

            <div className={styles.introBody}>
              <h3 className={styles.introTitle}>
                ليه <span className={styles.highlightText}>ماي ستور</span>{" "}
                مختلف؟
              </h3>
              <p className={styles.introDesc}>
                يا صديق ماي ستور، احنا مش بنشتغل عشان نشتغل، احنا بنشتغل بطريقة
                تخليك متأكد إننا خطوة قدام كل حد. ليه؟ عشان احنا بنفكر مختلف،
                بنركز على التفاصيل الصغيرة اللي بتحقق الفرق، وبنقدم حلول تعليمية
                تليق بذكائك وتطلعاتك المستقبليّة.
              </p>
            </div>

            <div className={styles.cardFooterGraphics}>
              <div className={styles.circleGraphic1} />
              <div className={styles.circleGraphic2} />
            </div>
          </div>

          <div className={styles.productsSide}>
            <motion.div layout className={styles.productsGrid}>
              <AnimatePresence>
                {visibleBooks.map((book) => (
                  <motion.div
                    layout
                    key={book.id}
                    className={styles.productCard}
                    whileHover={{ y: -8, transition: { duration: 0.2 } }}
                    onClick={() => setSelectedBook(book)}
                  >
                    <div className={styles.imageBox}>
                      <img
                        src={book.image}
                        alt={book.title}
                        className={styles.bookImg}
                      />
                      <button
                        className={styles.quickCartBtn}
                        onClick={(e) => {
                          e.stopPropagation();
                          alert("تمت الإضافة للسلة!");
                        }}
                      >
                        <ShoppingCart size={18} />
                      </button>
                    </div>

                    <div className={styles.cardMeta}>
                      <span className={styles.tagBadge}>{book.tag}</span>
                      <h4 className={styles.bookTitle} title={book.title}>
                        {book.title}
                      </h4>
                      <div className={styles.authorRow}>{book.author}</div>
                      <div className={styles.priceContainer}>
                        <span className={styles.priceText}>
                          {book.price} ج.م
                        </span>
                        <span className={styles.oldPriceText}>
                          {book.oldPrice}
                        </span>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </motion.div>
          </div>
        </div>

        <AnimatePresence>
          {selectedBook && (
            <>
              <motion.div
                className={styles.modalOverlay}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setSelectedBook(null)}
              />
              <motion.div
                className={styles.detailsModal}
                initial={{ opacity: 0, x: 100, scale: 0.95 }}
                animate={{ opacity: 1, x: 0, scale: 1 }}
                exit={{ opacity: 0, x: 100, scale: 0.95 }}
                transition={{ type: "spring", damping: 25, stiffness: 220 }}
              >
                <div className={styles.modalHeader}>
                  <button
                    className={styles.closeModalBtn}
                    onClick={() => setSelectedBook(null)}
                  >
                    <X size={22} />
                  </button>
                  <span className={styles.modalHeaderTitle}>
                    معاينة تفاصيل الكتاب
                  </span>
                </div>

                <div className={styles.modalBody}>
                  <div className={styles.modalImageWrapper}>
                    <img
                      src={selectedBook.image}
                      alt={selectedBook.title}
                      className={styles.modalLargeImg}
                    />
                  </div>

                  <h3 className={styles.modalBookTitle}>
                    {selectedBook.title}
                  </h3>
                  <p className={styles.modalSubtitle}>
                    {selectedBook.subtitle}
                  </p>

                  <div className={styles.modalPricingRow}>
                    <span className={styles.modalPrice}>
                      EGP {selectedBook.price}
                    </span>
                    <span className={styles.modalOldPrice}>
                      EGP {selectedBook.oldPrice}
                    </span>
                    <span className={styles.modalDiscountBadge}>
                      {selectedBook.discount}
                    </span>
                  </div>

                  <div className={styles.modalPillsGroup}>
                    <span className={`${styles.pills} ${styles.pillsCyan}`}>
                      {selectedBook.tag}
                    </span>
                    <span className={`${styles.pills} ${styles.pillsOrange}`}>
                      {selectedBook.level}
                    </span>
                  </div>

                  <div className={styles.modalDescriptionSection}>
                    <h5 className={styles.sectionLabel}>الوصف</h5>
                    <p className={styles.sectionParagraph}>
                      {selectedBook.desc}
                    </p>
                  </div>
                </div>

                <div className={styles.modalFooter}>
                  <button className={styles.mainActionBtn}>اضف للسلة</button>
                </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default BestSeller;
